// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"se-z","play":"te-z"};